import React from 'react';

const Blog = () => {
    return (
        <div className="container mx-auto p-6">
            <h1 className="text-3xl font-bold mb-4">Our Blog</h1>
            <p>
                Explore stories, service tips, and community updates. Coming soon!
            </p>
        </div>
    );
};

export default Blog;